<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2>آپلودر</h2>
            </div>
        </div>
        <!-- end main title -->

        <!-- form -->
        <div class="col-12">
            <div class="form">
                <div class="row">


                    <div class="col-8 col-md-8 ">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group ">
                                    <label>انتخاب سرور  </label>
                                    <select class="form__input col-3" v-model="server">
                                        <option value="" disabled selected>انتخاب کنید</option>
                                        <option value="dl1">dl 1</option>
                                        <option  value="dl3">dl 3</option>
                                    </select>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-4 col-md-4 ">
                                <div class="form__group">
                                    <ImageSelector label="فایل"
                                                   v-model:previewImage="file_preview"
                                                   @imagefile="(n) => file = n"
                                                   />

                                </div>
                    </div>



                    <div class="col-12">
                        <div class="row">
                          <div class="col-12 upload-ink">
                            {{download_link}}
                          </div>
                            <div class="col-12">
                                <p v-if="upload_percent!=''" style="color: white">
                                    {{upload_percent}}%
                                </p>
                                <button type="button" class="form__btn" @click="insert_data">{{status_form ==0 ?
                                    'افزودن' : 'ویرایش'}}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import Datatable from "@/views/customTable/Datatable";
    import ImageSelector from "@/views/CustomComponent/ImageSelector";

    export default {
        name: 'Country',
        data() {
            return {
                items: [],
                fields: [
                    {key: 'row', label: 'ردیف'},
                    {key: 'name', label: 'نام'},
                    {key: 'image', label: 'تصویر'},
                    {key: 'operation', label: 'عملیات'}
                ],
                status_form: 0,
                name: '',
                upload_percent:'',
                bio: '',
                file:null,
                file_preview:'',
                cover_file:null,
                cover_file_preview:'',
                download_link:'',
                server:'',
            }
        },
        components: {
            Datatable,
            ImageSelector
        },
        mounted() {
            // this.get_data();
        },
        methods: {
            edit_item(item) {
                this.name = item.name;
                this.bio = item.summary;
                this.file_preview = item.image;
                this.status_form = item.id;
                this.file=null
            },
            insert_data() {

                var self = this;

                var formData = new FormData();
                var url = 'upload_video'
                formData.append('server', this.server);
                formData.append('file', this.file);
                const config = {
                    onUploadProgress: progressEvent => self.upload_progress(progressEvent)
                }
                this.axios.post(url, formData, config).then(function (response) {
self.download_link = response.data
                    self.name = ''
                    self.bio = ''
                    self.file = null
                    self.status_form = 0;

                }).catch(function (error) {
                    console.log(error);
                });


            },
            upload_progress(progressEvent){
                this.upload_percent    = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
document.getElementsByClassName("loading-text")[0].innerHTML = "در حال آپلود "+this.upload_percent+"%"
                if(this.upload_percent>98){
                    document.getElementsByClassName("loading-text")[0].innerHTML = "لطفا صبر کنید"
                }
            }
        }
    }
</script>

